export const isFullStatic = false
export const staticPath = "/root/project/frontend/.nuxt/static-json"
export const publicPath = "https://frontenddev.builtin.com/f2b695a0b94b668648383e58f4bb57c55f0215ab/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"